import logEvent from '../logEvent';

function logEventWithdrawal(code, data) {
  logEvent(`WDRL${code}`, data);
}

export function logEventWithdrawalStart() {
  logEventWithdrawal('01');
}

export function logEventWithdrawalTimeForSchool() {
  logEventWithdrawal('02');
}

export function logEventWithdrawalSelectPlan(data) {
  logEventWithdrawal('03', data);
}

export function logEventWithdrawalSchoolDetails(data) {
  logEventWithdrawal('04', data);
}

export function logEventWithdrawalAmount(data) {
  logEventWithdrawal('05', data);
}

export function logEventWithdrawalManualAllocation(data) {
  logEventWithdrawal('06', data);
}

export function logEventWithdrawalBankAccount() {
  logEventWithdrawal('07');
}

export function logEventWithdrawalReview() {
  logEventWithdrawal('08');
}

export function logEventWithdrawalErrorCase() {
  logEventWithdrawal('ErrorCase');
}

export function logEventWithdrawalSuccess() {
  logEventWithdrawal('09');
}

export function logEventWithdrawalVerificationRequired() {
  logEventWithdrawal('10');
}

export function logEventWithdrawalVerifyBankAccount() {
  logEventWithdrawal('11');
}

export function logEventWithdrawalVerifyBankAccountSuccess() {
  logEventWithdrawal('12');
}
